import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getVehicleDataWithId, updateVehicle } from "adminApi/TransportFacilityApi/VehicleApi.js";
import { validateForm } from "utils/validation";
import { VehicleRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/VehicleFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import useFetchAllData from "Hooks/useFetchAllData";

const EditVehicle = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [formdata]);

    const {
        values,
        errors,
        handleChange,
        setErrors,
        setValues
    } = useFormChange(initialValues, VehicleRules);

    const fetchVehicle = useMemo(() => () => getVehicleDataWithId(id), [id]);
    const { data: vehicleData, loading: fetchLoading } = useFetchAllData(fetchVehicle);

    useEffect(() => {
        if (vehicleData) {
            setValues(vehicleData);
        }
    }, [vehicleData, setValues]);

    const { loading: updateLoading, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await updateVehicle({ id, data: formValues });
        },

        (vals) => {
            const err = validateForm(vals, VehicleRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Vehicle Updated Successfully"
    );

    const loading = fetchLoading || updateLoading;

    return (
        <PageBody
            headerchildren={<HeadingOne>Edit Vehicle</HeadingOne>}
            onSubmit={(e) => handleSubmit(e, values)}
        >
            {loading && <Spinner isSpinner />}
            {formdata.map((field) => (
                <FormInput
                    key={field.name}
                    field={field}
                    value={values[field.name] || ""}
                    handleChange={handleChange}
                    error={errors[field.name]}
                />
            ))}

            <FormSubmitButton
                label="Update"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditVehicle;
